module.exports = __webpack_public_path__ + "media/icons/stars-99f1270b.svg";